import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography, Button, CircularProgress, Alert } from "@mui/material";
import { baseUrl } from "../api/axiosClient";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(`${baseUrl}/auth/verify-email?token=${token}`);
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.message || "Verification failed");
        }

        setStatus("success");
        setTimeout(() => navigate("/login", { 
          state: { message: "Email verified successfully! You can now login." } 
        }), 3000);
      } catch (err) {
        setStatus("error");
        setError(err.message);
      }
    };

    if (token) {
      verifyEmail();
    } else {
      setStatus("error");
      setError("Invalid verification link");
    }
  }, [token, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        p: 3,
        textAlign: "center"
      }}
    >
      {status === "verifying" && (
        <>
          <CircularProgress size={60} sx={{ mb: 3 }} />
          <Typography variant="h5" gutterBottom>
            Verifying your email...
          </Typography>
        </>
      )}

      {status === "success" && (
        <>
          <Alert severity="success" sx={{ mb: 3, maxWidth: 500 }}>
            <Typography variant="h6">Email Verified Successfully!</Typography>
            <Typography>You will be redirected to login shortly.</Typography>
          </Alert>
        </>
      )}

      {status === "error" && (
        <>
          <Alert severity="error" sx={{ mb: 3, maxWidth: 500 }}>
            <Typography variant="h6">Verification Failed</Typography>
            <Typography>{error}</Typography>
          </Alert>
          <Button 
            variant="contained" 
            onClick={() => navigate("/signup")}
            sx={{ mt: 2 }}
          >
            Go to Sign Up
          </Button>
        </>
      )}
    </Box>
  );
};

export default VerifyEmail;
